/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  CheckCircle2,
  Search,
  Pencil,
  Plus,
  QrCode,
  X,
  Trash2,
  MinusCircle
} from 'lucide-react'
import { useEffect, useMemo, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { Link, useLocation } from 'react-router-dom'
import Select, { components } from 'react-select'
import { BadgeStatusCOA } from '../../../components/atoms/StatusLabel'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import ModalDownloadQr from '../../../components/modal/pallete/ModalDownloadQr'
import ModalTypeDownloadRack from '../../../components/modal/racks/ModalTypeDownloadRack'
import ModalStockAdjustment from '../../../components/modal/stockAdjustment/ModalStockAdjustment'
import api from '../../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 })
}

function DetailRackPage() {
  const { pathname, state } = useLocation()
  const refItemCode = useRef(null)
  const debounceTimeout = useRef(null)
  const [rackId, setRackId] = useState(pathname?.split('/')[4])
  const [editId, setEditId] = useState({})
  const [deleteId, setDeleteId] = useState(null)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const [isOpen, setIsOpen] = useState({
    add: false,
    delete: false,
    removeBulk: false
  })
  const [editSelected, setEditSelected] = useState([])
  const [itemCodeSelected, setItemCodeSelected] = useState([])
  const [itemCodeRemoveSelected, setItemCodeRemoveSelected] = useState([])
  const [itemSuggestionItemCodes, setItemSuggestionItemCodes] = useState([])

  const [data, setData] = useState({
    values: [],
    metadata: {
      per_page: 10,
      current_page: 1,
      total_row: 0,
      total_page: 0
    }
  })

  const [isLoading, setIsLoading] = useState(true)
  const [showDownloadQr, setShowDownloadQr] = useState(false)
  const [showTypeDownload, setShowTypeDownload] = useState(false)

  const [filter, setFilter] = useState({
    q: ''
  })
  const [debouncedQ, setDebouncedQ] = useState(filter.q)

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQ(filter.q)
      setData((prevData) => ({
        ...prevData,
        metadata: {
          ...prevData.metadata,
          current_page: 1
        }
      }))
    }, 1000)
    return () => clearTimeout(handler)
  }, [filter.q])

  const handlePageChange = (data) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: data.selected + 1
      }
    }))
    if (editSelected.length > 0) {
      setEditSelected([])
    }
    window.scrollTo(0, 0)
  }

  const handleOnChangeMeta = (e) => {
    setData((prevData) => ({
      ...prevData,
      metadata: {
        ...prevData.metadata,
        current_page: 1,
        per_page: parseInt(e.target.value, 10)
      }
    }))
    if (editSelected.length > 0) {
      setEditSelected([])
    }
    window.scrollTo(0, 0)
  }

  const fetchDetail = async (rackId) => {
    try {
      setIsLoading(true)
      const params = {
        q: debouncedQ,
        per_page: data?.metadata?.per_page || 10,
        page: data?.metadata?.current_page || 1
      }
      const response = await api.get(`master/racks/${rackId}/slots`, {
        params
      })
      const { data: dataResponse } = response
      setData({
        values: dataResponse.data?.map((item) => {
          return {
            ...item,
            slot_categories_prev_forms: item?.slot_categories?.map((slot) => {
              return {
                value: slot,
                label: slot
              }
            }),
            slot_categories_change_forms: item?.slot_categories?.map((slot) => {
              return {
                value: slot,
                label: slot
              }
            })
          }
        }),
        metadata: dataResponse.metadata
      })
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoading(false)
    }
  }

  const getItemCodeSuggestion = async (q) => {
    try {
      let optionValue = []
      const params = {
        q,
        limit: 30
      }
      const res = await api.get('/master/items/all', { params })
      if (res.data.data.length > 0) {
        res.data.data.map((item) =>
          optionValue.push({
            value: item.item_code,
            label: `${item.item_code} - ${item.item_name}`,
            name: item.item_name
          })
        )
      }
      setItemSuggestionItemCodes(optionValue)
    } catch (err) {
      const errMsg =
        err?.response?.data?.errors?.message ||
        err?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  function handleDownloadQr(data) {
    setShowDownloadQr(true)
    setEditId({
      ...editId,
      src: data.qr,
      paletName: data.code,
      id: data.id
    })
  }

  const handleEditSlot = (id, type = null) => {
    setEditId((prevEdit) => ({
      ...prevEdit,
      [id]: !prevEdit[id]
    }))
    if (type === 'cancel') {
      const getDataNotChange =
        data?.values?.find((item) => item.id === id)
          ?.slot_categories_prev_forms || []
      setData((prevData) => ({
        ...prevData,
        values: prevData.values.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              slot_categories_change_forms: getDataNotChange
            }
          }
          return item
        })
      }))
    }
  }

  const handleRemoveSuggestion = (slotId, itemCode) => {
    setData((prevData) => ({
      ...prevData,
      values: prevData.values.map((item) => {
        if (item.id === slotId) {
          return {
            ...item,
            slot_categories_change_forms:
              item.slot_categories_change_forms.filter(
                (item) => item.value !== itemCode
              )
          }
        }
        return item
      })
    }))
  }

  const handleChangeCheckbox = (id = null) => {
    if (!id) {
      const dataSelectedAll = data?.values?.map((item) => item.id) || []
      const isAllSelected =
        dataSelectedAll.length > 0 &&
        dataSelectedAll.every((id) => editSelected.includes(id))
      setEditSelected(isAllSelected ? [] : dataSelectedAll)
    } else {
      if (editSelected.includes(id)) {
        setEditSelected(editSelected.filter((item) => item !== id))
      } else {
        setEditSelected([...editSelected, id])
      }
    }
  }

  const handleUpdateCodeSuggestion = async (id = null) => {
    if (id) {
      const dataSuggestionCodeChange =
        data?.values?.find((item) => item.id === id)
          ?.slot_categories_change_forms || []
      if (dataSuggestionCodeChange.length === 0) {
        toast.error('Item code suggestion empty, please add first', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
      try {
        setLoadingSubmit(true)
        const payload = {
          slots: [
            {
              slot_id: id,
              slot_categories: dataSuggestionCodeChange?.map(
                (value) => value.value
              )
            }
          ]
        }
        const response = await api.put(`master/racks/${rackId}/slots`, payload)
        const { data: dataResponse } = response
        if (dataResponse.success) {
          toast.success('Successfully update item code suggestion', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
          fetchDetail(rackId)
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.errors?.message ||
          error?.message ||
          'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } finally {
        setLoadingSubmit(false)
        setEditId({})
      }
    } else {
      try {
        setLoadingSubmit(true)
        const payload = {
          slots: data?.values
            ?.filter((item) => editSelected.includes(item.id))
            ?.map((item) => {
              const existingCategories =
                item.slot_categories_change_forms?.map(
                  (value) => value.value
                ) || []
              const selectedCodes =
                itemCodeSelected?.map((value) => value.value) || []
              // Merge and remove duplicates using Set
              const mergedCategories = Array.from(
                new Set([...existingCategories, ...selectedCodes])
              )

              return {
                slot_id: item.id,
                slot_categories: mergedCategories
              }
            })
        }
        const response = await api.put(`master/racks/${rackId}/slots`, payload)
        const { data: dataResponse } = response
        if (dataResponse.success) {
          toast.success('Successfully update item code suggestion', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
          fetchDetail(rackId)
          handleModalAddItemSuggestion()
          setEditSelected([])
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.errors?.message ||
          error?.message ||
          'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } finally {
        setLoadingSubmit(false)
        setEditId({})
      }
    }
  }

  const handleDeleteCodeSuggestion = async (id = null) => {
    if (id) {
      try {
        setLoadingSubmit(true)
        const payload = {
          slots: [
            {
              slot_id: id,
              slot_categories: []
            }
          ]
        }
        const response = await api.put(`master/racks/${rackId}/slots`, payload)
        const { data: dataResponse } = response
        if (dataResponse.success) {
          toast.success('Successfully delete item code suggestion', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
          fetchDetail(rackId)
          handleModalDeleteItemSuggestion()
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.errors?.message ||
          error?.message ||
          'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } finally {
        setLoadingSubmit(false)
      }
    } else {
      try {
        if (editSelected.length === 0) {
          return toast.error('Item code suggestion empty, please add first', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
        }
        setLoadingSubmit(true)
        const payload = {
          slots: editSelected.map((id) => ({
            slot_id: id,
            slot_categories: []
          }))
        }
        const response = await api.put(`master/racks/${rackId}/slots`, payload)
        const { data: dataResponse } = response
        if (dataResponse.success) {
          toast.success('Successfully delete item code suggestion', {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          })
          fetchDetail(rackId)
          handleModalDeleteItemSuggestion()
        }
      } catch (error) {
        const errMsg =
          error?.response?.data?.errors?.message ||
          error?.message ||
          'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      } finally {
        setLoadingSubmit(false)
      }
    }
  }

  const handleModalAddItemSuggestion = () => {
    setIsOpen({
      ...isOpen,
      add: !isOpen.add
    })
    if (itemCodeSelected.length > 0) {
      setItemCodeSelected([])
    }
  }

  const handleModalDeleteItemSuggestion = () => {
    setIsOpen({
      ...isOpen,
      delete: !isOpen.delete
    })
    if (deleteId && !isOpen.delete) {
      setDeleteId(null)
    }
  }

  const handleModalRemoveBulkSuggestion = () => {
    setIsOpen({
      ...isOpen,
      removeBulk: !isOpen.removeBulk
    })
    if (itemCodeRemoveSelected.length > 0) {
      setItemCodeRemoveSelected([])
    }
  }

  const handleRemoveBulkCodeSuggestion = async () => {
    try {
      if (editSelected.length === 0) {
        return toast.error('Please select at least one slot', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
      if (itemCodeRemoveSelected.length === 0) {
        return toast.error('Please select at least one item code to remove', {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
      setLoadingSubmit(true)
      const codesToRemove = itemCodeRemoveSelected.map((v) => v.value)
      const payload = {
        slots: data?.values
          ?.filter((item) => editSelected.includes(item.id))
          ?.map((item) => {
            const existing =
              item.slot_categories_change_forms?.map((v) => v.value) || []
            return {
              slot_id: item.id,
              slot_categories: existing.filter(
                (code) => !codesToRemove.includes(code)
              )
            }
          })
      }
      const response = await api.put(`master/racks/${rackId}/slots`, payload)
      const { data: dataResponse } = response
      if (dataResponse.success) {
        toast.success(
          'Successfully removed item code suggestion from selected slots',
          {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          }
        )
        fetchDetail(rackId)
        handleModalRemoveBulkSuggestion()
        setEditSelected([])
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoadingSubmit(false)
    }
  }

  const handleInputChange = (inputValue, { action }) => {
    if (action !== 'input-change') return
    if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
    debounceTimeout.current = setTimeout(() => {
      getItemCodeSuggestion(inputValue)
    }, 500)
  }

  const CustomMultiValueLabel = (props) => {
    return (
      <components.MultiValueLabel {...props}>
        {props.data.value}
      </components.MultiValueLabel>
    )
  }

  const dataSlotItems = useMemo(() => {
    return (
      data?.values
        ?.filter((item) => item.is_active)
        ?.sort((a, b) => {
          const toParts = (code) =>
            code.split('.').map((p) => (/^\d+$/.test(p) ? Number(p) : p))
          const aParts = toParts(a.code)
          const bParts = toParts(b.code)
          const max = Math.max(aParts.length, bParts.length)
          const lastComparableIndex = Math.min(aParts.length, bParts.length) - 1
          for (let i = 0; i < max; i++) {
            const av = aParts[i]
            const bv = bParts[i]
            if (av === bv) continue
            const aNum = typeof av === 'number'
            const bNum = typeof bv === 'number'
            if (aNum && bNum) {
              if (i < lastComparableIndex) return bv - av
              return av - bv
            }
            return String(bv).localeCompare(String(av))
          }
          return 0
        }) || []
    )
  }, [data?.values, showTypeDownload])

  useEffect(() => {
    fetchDetail(rackId)
  }, [
    pathname,
    rackId,
    data?.metadata?.current_page,
    data?.metadata?.per_page,
    debouncedQ
  ])

  useEffect(() => {
    if (isOpen.add || isOpen.removeBulk) {
      getItemCodeSuggestion()
    }
  }, [isOpen.add, isOpen.removeBulk])

  return (
    <>
      <Toaster />
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <h3 style={headerTitleStyle}>Rack Detail</h3>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item rack-item">
                  <Link
                    to="/setting/racks"
                    state={{
                      id: state?.id,
                      warehouse_id: state?.warehouse_id,
                      q: state?.q
                    }}
                    className="text-decoration-none"
                  >
                    <span className="text-muted">
                      {state?.warehouseName || 'Warehouse'}
                    </span>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item rack-item active fw-bold"
                  aria-current="page"
                  style={{ color: 'var(--primary-orange)' }}
                >
                  {state?.rackName}
                </li>
              </ol>
            </nav>
          </Col>
          <Col className="text-end">
            <Button
              className="btn btn-primary-orange rounded px-4 py-2 fw-bold"
              onClick={() => setShowTypeDownload(true)}
              style={{ fontSize: '0.85rem' }}
            >
              <QrCode size={16} className="me-2" />
              Print All QR
            </Button>
          </Col>
        </Row>

        <Card
          style={{
            border: 'none',
            boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            backgroundColor: '#fff'
          }}
        >
          <Row className="align-items-center g-3">
            <Col md={editSelected.length > 0 ? 6 : 12}>
              <Form.Group>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={18} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search Slot..."
                    value={filter.q}
                    onChange={(e) => setFilter({ q: e.target.value })}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>

            {editSelected.length > 0 && (
              <Col md={6} className="text-end">
                <div className="d-flex justify-content-end gap-2 align-items-center">
                  <span
                    className="fw-bold me-2 text-muted"
                    style={{ fontSize: '0.9rem' }}
                  >
                    {editSelected.length} Selected
                  </span>
                  <Button
                    variant="light"
                    className="text-danger fw-bold rounded px-3 py-2 border"
                    onClick={handleModalDeleteItemSuggestion}
                    style={{ fontSize: '0.85rem' }}
                  >
                    <Trash2 size={16} className="me-2" />
                    Remove Suggestion
                  </Button>
                  <Button
                    variant="light"
                    className="fw-bold rounded px-3 py-2 border"
                    onClick={handleModalRemoveBulkSuggestion}
                    style={{
                      fontSize: '0.85rem',
                      color: '#C12727',
                      borderColor: '#C12727'
                    }}
                  >
                    <MinusCircle size={16} className="me-2" />
                    Remove Suggestion Bulk
                  </Button>
                  <Button
                    variant="light"
                    className="text-primary fw-bold rounded px-3 py-2 border"
                    onClick={handleModalAddItemSuggestion}
                    style={{
                      fontSize: '0.85rem',
                      color: 'var(--primary-orange) !important'
                    }}
                  >
                    <Plus size={16} className="me-2" />
                    Add Suggestion
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        </Card>

        <Row>
          <Col md={12}>
            <Table
              responsive
              hover
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th
                    className="p-2 align-middle text-center"
                    style={{ ...tableHeaderStyle, width: '5%' }}
                  >
                    <Form.Check type="checkbox" id="all-slot">
                      <Form.Check.Input
                        type="checkbox"
                        id="all-slot-checkbox"
                        checked={
                          data?.values?.length > 0 &&
                          editSelected.length ===
                            data?.values?.map((item) => item.id).length
                        }
                        disabled={
                          data?.values?.length === 0 || state?.type === 'ground'
                        }
                        style={{
                          cursor: `${
                            state?.type === 'ground' ? 'not-allowed' : 'pointer'
                          }`
                        }}
                        onChange={() => handleChangeCheckbox()}
                      />
                    </Form.Check>
                  </th>
                  <th
                    className="p-2 align-middle"
                    style={{ ...tableHeaderStyle, width: '15%' }}
                  >
                    Slot Name
                  </th>
                  <th
                    className="p-2 align-middle"
                    style={{ ...tableHeaderStyle, width: '10%' }}
                  >
                    Status
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Item Code Suggestion
                  </th>

                  {state?.type !== 'ground' && (
                    <th
                      className="p-2 align-middle text-center"
                      style={{ ...tableHeaderStyle, width: '15%' }}
                    >
                      Action
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td
                      className="p-5 text-center"
                      colSpan={state?.type === 'ground' ? 4 : 5}
                    >
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  data?.values?.map((data, i) => (
                    <tr
                      key={`${data.id}-${i}`}
                      style={{ borderBottom: '1px solid #f0f0f0' }}
                    >
                      <td className="p-2 align-middle text-center">
                        <Form.Check type="checkbox" id={`slot-${data.id}`}>
                          <Form.Check.Input
                            type="checkbox"
                            checked={editSelected.includes(data.id)}
                            value={data.id}
                            disabled={state?.type === 'ground'}
                            style={{
                              cursor:
                                state?.type === 'ground'
                                  ? 'not-allowed'
                                  : 'pointer'
                            }}
                            onChange={() => handleChangeCheckbox(data?.id)}
                          />
                        </Form.Check>
                      </td>
                      <td className="p-2 align-middle fw-semibold text-primary">
                        {data.code}
                      </td>
                      <td className="p-2 align-middle">
                        <BadgeStatusCOA
                          text={data.is_active ? 'active' : 'inactive'}
                        />
                      </td>
                      <td className="p-2 align-middle">
                        {(data?.slot_categories_change_forms?.length === 0 ||
                          !data?.slot_categories_change_forms) && (
                          <span className="text-muted">-</span>
                        )}
                        {data?.slot_categories_change_forms?.length > 0 && (
                          <div
                            style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '8px'
                            }}
                          >
                            {data?.slot_categories_change_forms?.map(
                              (slotCategories) => (
                                <div
                                  key={slotCategories.value}
                                  style={{
                                    border: editId[data.id]
                                      ? '1px solid var(--primary-orange)'
                                      : '1px solid #e9ecef',
                                    borderRadius: '50rem',
                                    padding: '4px 12px',
                                    fontSize: '0.8rem',
                                    backgroundColor: editId[data.id]
                                      ? '#fff5e6'
                                      : '#f8f9fa',
                                    color: editId[data.id]
                                      ? 'var(--primary-orange)'
                                      : '#333',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px'
                                  }}
                                >
                                  <span>{slotCategories.label}</span>
                                  {editId[data.id] && (
                                    <X
                                      size={14}
                                      style={{ cursor: 'pointer' }}
                                      onClick={() =>
                                        handleRemoveSuggestion(
                                          data.id,
                                          slotCategories.value
                                        )
                                      }
                                    />
                                  )}
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </td>
                      {state?.type !== 'ground' && (
                        <td className="p-2 align-middle text-center">
                          <div className="d-flex flex-row gap-2 justify-content-center">
                            {editId[data.id] ? (
                              <>
                                <button
                                  className="btn btn-danger rounded shadow-sm p-0 d-flex align-items-center justify-content-center"
                                  style={{ width: '35px', height: '35px' }}
                                  onClick={() => {
                                    handleEditSlot(data.id, 'cancel')
                                  }}
                                  disabled={loadingSubmit}
                                >
                                  <X size={16} />
                                </button>
                                <button
                                  className="btn btn-success rounded shadow-sm p-0 d-flex align-items-center justify-content-center"
                                  style={{ width: '35px', height: '35px' }}
                                  onClick={() => {
                                    handleUpdateCodeSuggestion(data.id)
                                  }}
                                  disabled={loadingSubmit}
                                >
                                  <CheckCircle2 size={16} />
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  className="btn btn-light text-secondary border rounded shadow-sm p-0 d-flex align-items-center justify-content-center"
                                  style={{ width: '35px', height: '35px' }}
                                  onClick={() => {
                                    handleDownloadQr(data)
                                  }}
                                  disabled={loadingSubmit}
                                  title="Print QR"
                                >
                                  <QrCode size={16} />
                                </button>

                                <button
                                  className={`btn btn-light text-primary border rounded shadow-sm p-0 d-flex align-items-center justify-content-center ${
                                    !data.slot_categories ? 'opacity-50' : ''
                                  }`}
                                  style={{ width: '35px', height: '35px' }}
                                  onClick={() => {
                                    handleEditSlot(data.id)
                                  }}
                                  disabled={
                                    loadingSubmit || !data?.slot_categories
                                  }
                                  title="Edit Suggestions"
                                >
                                  <Pencil size={16} />
                                </button>

                                <button
                                  className="btn btn-light text-danger border rounded shadow-sm p-0 d-flex align-items-center justify-content-center"
                                  style={{ width: '35px', height: '35px' }}
                                  onClick={() => {
                                    setDeleteId(data.id)
                                    handleModalDeleteItemSuggestion()
                                  }}
                                  disabled={loadingSubmit}
                                  title="Delete All Suggestions"
                                >
                                  <Trash2 size={16} />
                                </button>
                              </>
                            )}
                          </div>
                        </td>
                      )}
                    </tr>
                  ))
                )}
              </tbody>
              <tfoot>
                <tr>
                  <td
                    className="p-3 border-top-0"
                    colSpan={state?.type === 'ground' ? 4 : 5}
                  >
                    <TablePagination
                      meta={data.metadata}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </Container>

      <ModalStockAdjustment
        show={isOpen.add}
        onHide={handleModalAddItemSuggestion}
        title="Add Suggestion Code"
        size="lg"
        backdrop="static"
      >
        <Modal.Body
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: '100px' }}
        >
          <div className="w-100">
            <Col md={12}>
              <Select
                isClearable
                id="pic"
                defaultValue={[]}
                filterOption={(option, inputValue) => {
                  const { label, name } = option.data
                  const search = inputValue.toLowerCase()
                  return (
                    name?.toLowerCase().includes(search) ||
                    label?.toLowerCase().includes(search)
                  )
                }}
                styles={SelectStyles}
                onChange={(e) => {
                  if (!e) {
                    e = {
                      target: refItemCode,
                      value: ''
                    }
                  } else if (Array.isArray(e)) {
                    e = e.map((item) => ({
                      value: item.value,
                      label: item.label
                    }))
                  } else {
                    e = {
                      value: e.value,
                      label: e.label
                    }
                  }

                  setItemCodeSelected(e)
                  getItemCodeSuggestion('')
                }}
                options={itemSuggestionItemCodes || []}
                onInputChange={handleInputChange}
                placeholder="Select Item Code Suggestion"
                isSearchable
                ref={refItemCode}
                components={{ MultiValueLabel: CustomMultiValueLabel }}
                isMulti
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Col>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <Button
              variant="transparent"
              onClick={handleModalAddItemSuggestion}
            >
              Cancel
            </Button>
            <Button
              variant="transparent"
              className={`${
                itemCodeSelected.length > 0 && !loadingSubmit
                  ? 'btn-primary-orange'
                  : 'btn-secondary opacity-25'
              }`}
              disabled={itemCodeSelected.length === 0 || loadingSubmit}
              onClick={() => handleUpdateCodeSuggestion()}
            >
              Submit
            </Button>
          </div>
        </Modal.Footer>
      </ModalStockAdjustment>

      <ModalStockAdjustment
        show={isOpen.delete}
        onHide={handleModalDeleteItemSuggestion}
        title=""
        size="md"
        backdrop={true}
      >
        <div className="p-2 mt-3 text-center">
          <div className="d-flex justify-content-center">
            <svg
              width="181"
              height="180"
              viewBox="0 0 181 180"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M90.5 0C40.7991 0 0.5 40.2991 0.5 90C0.5 139.701 40.7991 180 90.5 180C140.201 180 180.5 139.701 180.5 90C180.5 40.2991 140.201 0 90.5 0ZM90.5 164.732C49.2366 164.732 15.7679 131.263 15.7679 90C15.7679 48.7366 49.2366 15.2679 90.5 15.2679C131.763 15.2679 165.232 48.7366 165.232 90C165.232 131.263 131.763 164.732 90.5 164.732Z"
                fill="#828282"
              />
              <path
                d="M80.8574 125.357C80.8574 127.915 81.8734 130.367 83.6817 132.176C85.4901 133.984 87.9428 135 90.5003 135C93.0577 135 95.5104 133.984 97.3188 132.176C99.1272 130.367 100.143 127.915 100.143 125.357C100.143 122.8 99.1272 120.347 97.3188 118.539C95.5104 116.73 93.0577 115.714 90.5003 115.714C87.9428 115.714 85.4901 116.73 83.6817 118.539C81.8734 120.347 80.8574 122.8 80.8574 125.357ZM85.6789 102.857H95.3217C96.2056 102.857 96.9289 102.134 96.9289 101.25V46.6071C96.9289 45.7232 96.2056 45 95.3217 45H85.6789C84.7949 45 84.0717 45.7232 84.0717 46.6071V101.25C84.0717 102.134 84.7949 102.857 85.6789 102.857Z"
                fill="#828282"
              />
            </svg>
          </div>
          <div className="my-3">
            <h5 className="fw-bold">Remove Item Slot Suggestion?</h5>
          </div>
        </div>
        <Modal.Footer>
          <hr />
          <div className="d-flex gap-2">
            <Button
              variant="transparent"
              disabled={loadingSubmit}
              onClick={handleModalDeleteItemSuggestion}
            >
              Cancel
            </Button>
            <Button
              variant="transparent"
              className={`${
                loadingSubmit
                  ? 'btn-secondary opacity-25'
                  : 'btn-primary-orange'
              }`}
              disabled={loadingSubmit}
              onClick={() => handleDeleteCodeSuggestion(deleteId)}
            >
              Remove
            </Button>
          </div>
        </Modal.Footer>
      </ModalStockAdjustment>

      {/* Modal Remove Suggestion Bulk */}
      <ModalStockAdjustment
        show={isOpen.removeBulk}
        onHide={handleModalRemoveBulkSuggestion}
        title="Remove Suggestion Bulk"
        size="lg"
        backdrop="static"
      >
        <Modal.Body
          className="d-flex align-items-center justify-content-center"
          style={{ minHeight: '100px' }}
        >
          <div className="w-100">
            <p className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
              Pilih item code yang ingin dihapus dari{' '}
              <strong>{editSelected.length} slot</strong> yang dipilih.
            </p>
            <Col md={12}>
              <Select
                isClearable
                id="remove-bulk-item-code"
                value={itemCodeRemoveSelected}
                filterOption={(option, inputValue) => {
                  const { label, name } = option.data
                  const search = inputValue.toLowerCase()
                  return (
                    name?.toLowerCase().includes(search) ||
                    label?.toLowerCase().includes(search)
                  )
                }}
                styles={SelectStyles}
                onChange={(e) => {
                  setItemCodeRemoveSelected(Array.isArray(e) ? e : e ? [e] : [])
                  getItemCodeSuggestion('')
                }}
                options={itemSuggestionItemCodes || []}
                onInputChange={handleInputChange}
                placeholder="Select Item Code to Remove"
                isSearchable
                components={{ MultiValueLabel: CustomMultiValueLabel }}
                isMulti
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </Col>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <Button
              variant="transparent"
              onClick={handleModalRemoveBulkSuggestion}
              disabled={loadingSubmit}
            >
              Cancel
            </Button>
            <Button
              variant="transparent"
              className={`${
                itemCodeRemoveSelected.length > 0 && !loadingSubmit
                  ? 'btn-primary-orange'
                  : 'btn-secondary opacity-25'
              }`}
              disabled={itemCodeRemoveSelected.length === 0 || loadingSubmit}
              onClick={handleRemoveBulkCodeSuggestion}
            >
              {loadingSubmit ? 'Removing...' : 'Remove'}
            </Button>
          </div>
        </Modal.Footer>
      </ModalStockAdjustment>

      <ModalDownloadQr
        show={showDownloadQr}
        onHide={() => {
          setShowDownloadQr(false)
          setEditId({})
        }}
        paletData={editId}
        type={'Slot'}
        slots={
          data?.values?.filter(
            (item) => item.id === editId.id && item.is_active
          ) || []
        }
      />

      <ModalTypeDownloadRack
        show={showTypeDownload}
        onHide={() => {
          setShowTypeDownload(false)
        }}
        slots={dataSlotItems}
      />
    </>
  )
}

export default DetailRackPage
